import type { CompleteAuthUser } from "../stores/useAuthStore";

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "";

/**
 * True only for an identity the app can safely run on: a non-empty email
 * and a platform role. Anything else (a partial user saved by an older
 * build's JWT-claims fallback, a malformed /users/me body, a corrupt
 * sessionStorage value) is treated as "no user" — rendering with it is what
 * produced placeholder identities and role-less 404s.
 *
 * The role's value isn't checked against the known roles: the backend
 * stores it as a non-null enum, so presence is what actually goes missing.
 */
export function isCompleteUser(user: unknown): user is CompleteAuthUser {
  if (typeof user !== "object" || user === null) return false;
  const { email, platformRole } = user as Record<string, unknown>;
  return isNonEmptyString(email) && isNonEmptyString(platformRole);
}
